<template>
    <section>
        <vue-good-table
            mode="remote"
            v-on:page-change="onPageChange"
            v-on:per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :isLoading.sync="isLoading"
            :pagination-options="{
                enabled: true,
                perPageDropdown: [10, 20, 30, 40, 50, 100],
                dropdownAllowAll: false,
            }"
            :rows="rows"
            :columns="columns"
            :sort-options="{
                enabled: false
            }"
        >
            <template #table-row="props">
                <span v-if="props.column.field === 'action'">      
                    <div class="d-flex align-items-center col-actions">
                        <template v-if="props.row.payload?.letter?.isQuadient">
                            <template v-if="props.row.payload?.letter?.canCanceled == false">
                                <a
                                    type="button"
                                    v-if="this.$route.params && this.$route.params.client"
                                    class="mr-1 text-primary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="View Mail"
                                    @click="disputeLetterStore.display = 2; disputeLetterStore.mail_id = props.row.id"
                                >
                                    <vue-feather type="eye"></vue-feather>
                                </a>
                                <router-link
                                    v-else
                                    class="mr-1 text-primary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="View Mail"
                                    :to="{ name: 'mail-show', params: { mail: props.row.id }}"
                                >
                                    <vue-feather type="eye"></vue-feather>
                                </router-link>
                            </template>
                            <template v-else>
                                <a
                                    type="button"
                                    class="mr-1 text-secondary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Letter is currently being processed"
                                >
                                    <vue-feather type="eye"></vue-feather>
                                </a>
                            </template>
                        </template>
                        <template v-else>
                            <a
                                type="button"
                                v-if="this.$route.params && this.$route.params.client"
                                class="mr-1 text-primary"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="View Mail"
                                @click="disputeLetterStore.display = 2; disputeLetterStore.mail_id = props.row.id"
                            >
                                <vue-feather type="eye"></vue-feather>
                            </a>
                            <router-link
                                v-else
                                class="mr-1 text-primary"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="View Mail"
                                :to="{ name: 'mail-show', params: { mail: props.row.id }}"
                            >
                                <vue-feather type="eye"></vue-feather>
                            </router-link>
                        </template>
                        <a
                            v-if="props.row.payload?.letter?.isQuadient && (props.row.payload?.letter?.canCanceled == true)"
                            class="mr-1 text-danger"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="`You may cancel this letter with in ${lobSettingStore.quadientPreOperationalPeriod} minutes`"
                        >
                            <vue-feather type="slash" @click="cancelMail(props.row.id)"></vue-feather>
                        </a>
                        <!-- <a class="mr-1 text-danger">
                            <vue-feather type="x-octagon" @click="deleteMail(props.row.id)"></vue-feather>
                        </a> -->
                    </div>
                </span>
                <!-- <img class="img-thumbnail" v-if="props.column.field == 'thumbnail'" :src="props.row.thumbnails[0].small" /> -->
            </template>
        </vue-good-table>
    </section>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import 'vue-good-table-next/dist/vue-good-table-next.css'
    import { VueGoodTable } from 'vue-good-table-next';
    import moment from 'moment';
    import { useDisputeLetterStore } from '../../stores/DisputeLetterStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js';
    import { useUserStore } from '../../stores/UserStore.js'
    import { useLobSettingStore } from '../../stores/LobSettingStore.js';
    import Swal from 'sweetalert2'
    import { closeModal, openModal, hideModal, centToDollar, formatDate } from '../../utilities/_helpers'
    import { fix, add } from 'mathjs'
    export default {
        components: {
            VueGoodTable,
        },
        setup(props) {
            return {
                moment: moment,
                centToDollar: centToDollar,
                formatDate: formatDate,
                disputeLetterStore: useDisputeLetterStore(),
                userStore: useUserStore(),
                lobSettingStore: useLobSettingStore(),
            }
        },
        async mounted() {
            await this.userStore.fetchUser();
            if (this.$route.params?.client) {
                Echo.channel(`UpdateMailStatus.Client.${this.userStore.user.id}`)
                .listen('.update', (e) => {
                    this.getMails();
                });
            }
            else {
                Echo.channel(`UpdateMailStatus.${this.userStore.user.id}`)
                .listen('.update', (e) => {
                    this.getMails();
                });
            }
            this.getMails();
        },
        data(){
            return {
                isLoading: true,
                currentPage: 1,
                currentPerPage: 10,
                totalRecords: 0,
                columns: [
                    {
                        label: 'Cost',
                        field: 'payload.letter.cost',
                        type: 'string',
                        field: this.getPrice,
                    },
                    {
                        label: 'File Name',
                        field: 'response',
                        type: 'string',
                        field: this.getFileName,
                    },
                    {
                        label: 'Number Of Pages',
                        field: 'payload.letter.number_of_pages',
                        type: 'number',
                    },
                    {
                        label: 'Envelope Size',
                        field: 'payload.letter.envelopSize',
                        type: 'string',
                    },
                    {
                        label: 'Mail Type',
                        field: 'payload.letter.emailService',
                        type: 'string',
                    },
                    {
                        label: 'Date Created',
                        field: this.getCreatedAt,
                        // type: 'date',
                        // dateInputFormat: 'yyyy-MM-dd',
                        // dateOutputFormat: 'MMM do yy',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                    }
                ],
                rows: [],
                searchTerm: '',
                localizationStore: useLocalizationStore(),
            };
        },
        watch: {
        },
        methods: {
            getMails(url, limit) {
                let $this = this;
                const route = this.$router.resolve(
                    {
                        name: 'mails-list',
                        params: {
                            client: $this.$route.params.client,
                            team: $this.$route.params.team,
                        }
                    }
                );
                axios.get(
                    route.href,
                    {
                        params: {
                            currentPage: $this.currentPage,
                            currentPerPage: $this.currentPerPage,
                            searchTerm: $this.searchTerm
                        }
                    }
                ).then(function(response) {
                    $this.isLoading = false;
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.rows = response.data.data.rows
                    $this.totalRecords = response.data.data.totalRecords
                    return;
                }).catch(function(error) {
                    setTimeout(() => {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            },
            onPageChange(params) {
                this.currentPage = params.currentPage;
                this.getMails();
            },
            onPerPageChange(params) {
                this.currentPerPage = params.currentPerPage;
                this.currentPage = 1;
                this.getMails();
            },
            onSearch(params){
                this.searchTerm = params.searchTerm;
                this.getMails();
            },
            cancelMail(id) {
                let $this = this;
                Swal.fire({
                    title: 'Are you sure you want to Cancel a Mail?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        const route = $this.$router.resolve(
                            {
                                name: 'mails-cancel',
                                params: {
                                    mail: id,
                                    client: $this.$route.params.client,
                                    team: $this.$route.params.team,
                                }
                            }
                        );
                        axios.post(route.href).then(function(response) {
                            $this.getMails();
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.userStore.user.balance = response.data.data.balance;
                            toastr.success(response.data.message, 'Success!');
                            return;
                        }).catch(function(error) {
                            toastr.error(error.response.data.error.message, 'Error!');
                        });
                    }
                });
            },
            deleteMail(id) {
                let $this = this;
                Swal.fire({
                    title: 'Are you sure you want to delete a Mail?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        const route = $this.$router.resolve(
                            {
                                name: 'mails-destroy',
                                params: {
                                    mail: id
                                }
                            }
                        );
                        axios.delete(route.href).then(function(response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.getMails();
                            toastr.success(response.data.message, 'Success!');
                            return;
                        }).catch(function(error) {
                            toastr.error(error.response.data.error.message, 'Error!');
                        });
                    }
                });
            },
            getFileName(row)
            {
                return row.payload.letter ? row.payload.letter.name : row.response.letters[0].documents[0].fileName;
            },
            getPrice(row) {
                return row.payload.letter?.cost ? `$${row.payload.letter.cost}` : "";
            },
            getCreatedAt(row) {
                return  this.formatDate(row.created_at, 'llll');
            }
        }
    }
</script>